import { lazyNamed } from 'src/utils/lazyNamed.ts';

const Accounts = {
  AccountsList: lazyNamed(() => import('./containers/AccountsList/index.tsx'), 'AccountsList'),
  AccountOverview: lazyNamed(() => import('./containers/AccountOverview/index.tsx'), 'AccountOverview'),
  AccountForm: lazyNamed(() => import('./containers/AccountForm/index.tsx'), 'AccountForm'),
  ConversionTrackerForm: lazyNamed(() => import('./containers/ConversionTrackerForm/index.tsx'), 'ConversionTrackerForm'),
};

export default Accounts;
